import React from 'react';

import { ToastProvider } from './ToastProvider';
import { ToastDisplay } from './ToastDisplay';

export const Toaster = ({ children }) => {
  return (
    <ToastProvider>
      {children}
      <ToastDisplay />
    </ToastProvider>
  );
};
